export default "__VITE_ASSET__DmuajAKD__"